import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { orderState, purchaseOrdersSlice } from './orderSlice';

// API
import  {
  
  iPurchaseOrderResponse,
  
  sortDirectionType,
} from '../../../services/api/api';

// Components
import TableActionBar from '../../../components/TableActionBar/TableActionBar';

import {
  EllipsisLoader,
  WhiteboxLoader,
} from '../../../components/Loader/Loader';

import { Confirm } from '../../../components/Alerts/Alerts';
import { havePermission } from '../../../services/hoc/permissions';
import { Col, Row } from 'react-grid-system';

import { useLocation, useNavigate } from 'react-router-dom';

import { OrderStatus } from '../../../components/OrderStatus';

import { useNotification } from '../../../services/usenotification';
import { Receipt } from '@mui/icons-material';
import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '@mui/material';
import { getListSort } from '../../../services/hoc/sort';
import { SortTable } from '../../../components/Table/SortTable';
import { RowContainer } from '../../../components/Table/row_container';

import { useAPI } from '../../../services/hoc/useAPI';
import { AxiosError } from 'axios';


const Orders = () => {
  // Translation
  const t = useTranslation();
  const { alert, alertError500 } = useNotification();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  

  const navigate = useNavigate();
  const location = useLocation();
  const keyword_ref = useRef<string|null>(null)
  const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})
  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { purchaseOrder: orderState }) => state.purchaseOrder,
  );

  // Hooks


const ENDPOINTS = useAPI()


  // Search
  const search = (value: string) => {
    
    dispatch(purchaseOrdersSlice.actions.reset());
  keyword_ref.current=Boolean(value)?value:null
    fetchData(1,Boolean(value)? 20:8, value);
  };

  // Fetch Data
  const fetchData =useCallback( (
    page: number,
    page_size: number = 10,
    keyword?: string,
    sort_direction?:sortDirectionType,
    sort_field?:number

  ) => {
  
    dispatch(purchaseOrdersSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.purchaseOrder()
      .index({
        page,
        page_size,
        keyword,
        sort_direction,
        sort_field
      })
      .then((response) => {
        dispatch(purchaseOrdersSlice.actions.setIsFetching(false));
        dispatch(purchaseOrdersSlice.actions.setPage(pagesInfo.page));
        // if (response.data.data.last_page)
        //   setPagesInfo((pre) => ({
        //     ...pre,
        //     lastPage: response.data.data.last_page,
        //   }));
        let orders: iPurchaseOrderResponse[] =
          response.data.data.purchaseorders.map(
            (order: any): iPurchaseOrderResponse => ({
              id: order.id,
              ...order,
            }),
          );

        dispatch(purchaseOrdersSlice.actions.init(orders));
        dispatch(
          purchaseOrdersSlice.actions.setOrder({
            showOrder: true,
            order: orders[0],
          }),
        );
        dispatch(
          purchaseOrdersSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );

        if (!state.isLoaded)
          dispatch(purchaseOrdersSlice.actions.setIsLoaded(true));
        dispatch(purchaseOrdersSlice.actions.setIsFetching(false));
      })
      .catch((err: AxiosError) => {
        alertError500(err)
        dispatch(purchaseOrdersSlice.actions.setIsFetching(false));
      });
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
      sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field

      //setSortOptions(pre=>({...pre,sort_direction,sort_field}))
      fetchData(state.page,8,'',sort_direction,sort_field)
    }
  },[state.page])

  // Fetch Services



  const order_agreement = (order: iPurchaseOrderResponse) => (
    <div
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        //setOrderStatus((pre) => ({ ...pre, open: true, id: order.id }));
      }}>
      <OrderStatus
        order_status={order.order_status ? order.order_status : 'Pending'}
      />
    </div>
  );
  const issue_bill = (order: iPurchaseOrderResponse) => (
    <div onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <IconButton
       style={{
              display:'flex',
              justifyContent:'center'
            }}
        value={order.invoice_issued ? true : false}
        doTitle={t('issue_invoice')}
        disabled={
          havePermission('Issue Purchase Bill')
            ? order.order_status === 'Approved'
              ? false
              : true
            : true
        }
        cancelTitle={t('cancel_invoice_issued')}
        doFunction={() => {
          dispatch(
           
            purchaseOrdersSlice.actions.updateInvoiceIssued({
              id: order.id,
              invoice_issued: order.invoice_issued === 0 ? 1 : 0,
            }),
          );
          if (order.invoice_issued === 0 && order.order_status === 'Approved') {
            navigate(`/create-purchase-bill/${order.id}/`);
          } else {
            if (order.invoice_issued !== 0) {
              alert(
                {
                  en: 'This order has been issued before ',
                  ar: 'تم اصدار فاتورة هذه الطلبية من قبل',
                },
                'info',
              );
            }
            if (order.order_status !== 'Approved') {
              alert(
                {
                  en: 'This order must be approved in order to issue bill of it ',
                  ar: 'هذه الطلبية يجب الموافق عليها قبل اصدار فاتورة منها ',
                },
                'info',
              );
            }
          }
          return true;
        }}
        DoIcon={<Receipt style={{ color: 'var(--primary-color)' }} />}
      />
    </div>
  );
  const actions = (order: iPurchaseOrderResponse) => (
    <div className="show-on-hover">
      <Tooltip title={t('info')}>
        <i
          className="icon-info"
          onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            e.stopPropagation();
            navigate(`/add-purchase-order/${order.id}`);
          }}
        />
      </Tooltip>

      {havePermission('Delete Purchase Order') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(order.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );
  const rows = () => {
    return state.orders[state.page]
      ? state.orders[state.page].map((order, index) => {
          return (
            <RowContainer
             key={`${order.id} ${index}Row_container`}
              item_id={order.id.toString()}
              tr_index={index}
              state_length={state.orders[state.page].length}
              onSelect={toggleSelectedId}
              columns={[
                order.order_no,
                order.supplier?.name,

                order.date?.replaceAll('-','/'),
                order_agreement(order),
                issue_bill(order),
                actions(order),
              ]}
            />
          );
        })
      : null;
  };

  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Purchase Order')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(purchaseOrdersSlice.actions.setIsLoading(true));
    ENDPOINTS.purchaseOrder()
      .delete({ ids })
      .then(() => {
        dispatch(purchaseOrdersSlice.actions.setIsLoading(false));
        setSelectedIds([]);
        alert(
          { en: 'your deletion was succefull', ar: 'تم الحذف بنجاح' },
          'success',
        );
        dispatch(purchaseOrdersSlice.actions.deleteMaterials(ids));
      })
      .catch((err: any) => {
        dispatch(purchaseOrdersSlice.actions.setIsLoading(false));
        alertError500(err);
      });
  };

  // Delete

  // First fetch
  useEffect(() => {
    if (location.state) {
      if (!state.isFetching) {
       
        search(location.state.key)
      }
    } else {
      if (!state.isFetching) {
        
        fetchData(1);
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        
        purchaseOrdersSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page,8,keyword_ref.current??'',sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo.page ]);
  

  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <Row>
            <Col md={12}>
              <div
                style={{
                  maxHeight: 'calc(100vh - 130px)',
                  overflow: 'hidden auto',
                }}>
                <TableActionBar
                  keyword={location.state ? location.state.key : ''}
                  title={t('purchase_orders')}
                  search={search}
                  showFilter={false}
                  showDelete={selectedIds.length > 0}
                  delete={() => {
                    Confirm({
                      message: t('delete_confirmation'),
                      onConfirm: () => remove(),
                    });
                  }}
                  addText={t('add_purcahse_order')}
                  add={
                    havePermission('Add Purchase Order')
                      ? () => navigate('/add-purchase-order')
                      : undefined
                  }
                />

                {/* <DashboardTable
          
                  header={[t('supplier')
                  , t('purchase_number')
                  ,t("purchase_date")
                  , t("order_status"), t("issue_invoice"), '']}
                  body={generateData()}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={()=>{}}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  sort_fields={getListSort(['supplier_name'
                    ,'order_no','date','order_status','invoice_issued'
                    ,''],'Purchase_Order')}
                    fetchSortedData={fetchSortedData}
                /> */}
                <SortTable
                  header={[
                    t('purchase_number'),
                    t('supplier'),

                    t('purchase_date'),
                    t('order_status'),
                    t('issue_invoice'),
                    '',
                  ]}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={() => {}}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  sort_fields={getListSort(
                    [
                      'order_no',
                      'supplier_name',
                      'date',
                      'order_status',
                      'invoice_issued',
                      '',
                    ],
                    'Purchase_Order',
                  )}
                  fetchSortedData={fetchSortedData}
                  state={state.orders[state.page] ?? []}>
                  <>{rows()}</>
                </SortTable>
              </div>
              <div></div>
            </Col>
          </Row>
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default Orders;